import type { AdminAccountCompany } from "@portal/api/account/admin";
import { PortaledTooltip } from "@portal/components/ui/Tooltip";
import { FC } from "react";

type CompanyCreditNameCellProps = {
	companyId: AdminAccountCompany["id"];
	name: string;
	creditReportName: string | undefined;
};

export const CompanyCreditNameCell: FC<CompanyCreditNameCellProps> = ({
	companyId,
	name,
	creditReportName,
}) => {
	if (creditReportName === undefined || creditReportName === name) {
		return <span>{name}</span>;
	}
	const tooltipId = `company-credit-report-name-${companyId}`;
	return (
		<>
			<span data-tooltip-id={tooltipId} data-testid="company_credit_name">
				{name}
			</span>
			<PortaledTooltip
				id={tooltipId}
				content={`Credit report: ${creditReportName}`}
				place="top"
				delayShow={200}
			/>
		</>
	);
};
